import React, { useState } from "react";
import styled from "styled-components";
import ScrollContainerX from "../../components/ScrollContainer/ScrolContainerX";

export const CarouselWrapper = styled.div`
  display: flex;
  width: calc(100% + 20px); // espaço para o preview
  overflow: hidden;
`;

export const CarouselContainer = styled.div`
  display: flex;
  width: calc(100% + 20px); // espaço para o preview
  scroll-snap-type: x mandatory;
`;

export const CarouselItem = styled.div`
  flex: 0 0 40rem;
  padding: 10px;
  scroll-snap-align: start;
  box-sizing: border-box;
  // Adicione mais estilos para os itens aqui
`;

export const PreviewItem = styled(CarouselItem)`
  flex: 0 0 40rem;
`;

interface CarouselProps {
  items: JSX.Element[];
  styles?: {};
}

const Carousel: React.FC<CarouselProps> = ({ items, styles }) => {
  return (
    <ScrollContainerX speed={1}>
      <CarouselContainer>
        {items.map((item, index) => (
          <CarouselItem key={index} style={styles}>{item} </CarouselItem>
        ))}
      </CarouselContainer>
    </ScrollContainerX>
  );
};

export default Carousel;
